/**
 * A steady colour per person for their initials avatar, so a list of members
 * reads as different people at a glance instead of one block of the same tint.
 * Picked from the name (or id), so the same person keeps the same colour.
 */
const AVATAR_COLOURS = [
  '#2563EB',
  '#9333EA',
  '#0D9488',
  '#DB2777',
  '#64748B',
  '#0891B2',
  '#CA8A04',
  '#16A34A',
  '#E11D48',
  '#7C3AED',
  '#059669',
  '#EA580C',
]

export function avatarColour(seed: string): string {
  let hash = 0
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) | 0
  return AVATAR_COLOURS[Math.abs(hash) % AVATAR_COLOURS.length]
}
